import { INVENTORY, PLACEMENT_TYPE_HERO } from "../helpers/consts";
import { TILES } from "../helpers/tiles";
import Sprite from "../components/object-graphics/Sprite";
import { PickupPlacement } from "./PickupPlacement";

export class WaterGogglesPickupPlacement extends PickupPlacement {
  addsItemToInventoryOnCollide(body) {
    if (body.type === PLACEMENT_TYPE_HERO) {
      return INVENTORY.WATER_PICKUP;
    }
    return null;
  }

  canBeStolen() {
    return true;
  }

  renderComponent() {
    return <Sprite frameCoord={TILES.WATER_PICKUP} />;
  }
}
